import { createActionGroup, props } from '@ngrx/store';
import { FullscreenLayoutAreas } from '@src/assets/css/fullscreen.template.scss';

export const RecordMosActions = createActionGroup({
    source: 'Record Mos',
    events: {
        'Request MOS Record': props<{ sidecar: FullscreenLayoutAreas; mosPluginId?: string; record: StorytellingRecord }>(),
    },
});
